import { render, staticRenderFns } from "./marketplace-details-charts.component.vue?vue&type=template&id=0378b75a&scoped=true"
import script from "./marketplace-details-charts.component.vue?vue&type=script&lang=js"
export * from "./marketplace-details-charts.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace-details-charts.component.vue?vue&type=style&index=0&id=0378b75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0378b75a",
  null
  
)

export default component.exports